<template>
  <div>
    <!-- <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="viewnode-tab"
          data-bs-toggle="tab"
          data-bs-target="#viewnode"
          type="button"
          role="tab"
          aria-controls="viewnode"
          aria-selected="true"
        >
          view
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="edit-tab"
          data-bs-toggle="tab"
          data-bs-target="#operations"
          type="button"
          role="tab"
          aria-controls="operations"
          aria-selected="false"
        >
          Edit
        </button>
      </li>
    </ul> -->
    <div v-if="!editMode">
      <!-- {{content}} -->
      <div v-if="content.tjType === 'image' || content.tjType === 'note-image'">
        <img :src="content.img" width="100%" height="100%" alt="" />
      </div>
      <div v-else-if="content.tjType === 'custom-node'">
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            wikiDescription__heading
          "
        >
          <h3 v-html="contentDescription(content.label || '')"></h3>
          <div class="d-flex mx-1"
          v-if="!(this.$store.state.routeInfo === 'embed')"
          >
            <i
              title="Edit Mode"
              class="
                box-icon box-icon--effect
                details-controllers-margin
                bx bx-edit-alt
              "
              @click="toggleEditMode"
            />
          </div>
        </div>
        <TextAnalysis
          :content="content.description"
          :label="label"
          Mode="Default"
        />
      </div>
      <div v-else-if="content.tjType === 'note-text'">
        <div class="px-1 py-3">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              wikiDescription__heading
            "
          >
            <h3 v-html="contentDescription(content.label || '')"></h3>
            <div class="d-flex">
              <TextToSpeech :speech="content.description" :label="label" />
              <i
                v-if="!(this.$store.state.routeInfo === 'embed')"
                title="Edit Mode"
                class="
                  box-icon box-icon--effect
                  details-controllers-margin
                  bx bx-edit-alt
                "
                @click="toggleEditMode"
              />
            </div>
          </div>
          <TextAnalysis :content="content.description" Mode="Sentences" />
          <!-- <div v-html="contentDescription(content.description)"></div> -->
        </div>
        <div>
          <li v-for="(value, prop) in formDataObj.props" :key="prop">
            {{ prop }} - {{ value }}
          </li>
        </div>
        <div class="px-1 py-3" v-if="content.tjData">
          <h6>Source:</h6>
          <a
            class="px-1 py-3"
            v-if="content.tjData.url"
            :href="content.tjData.url"
            target="_blank"
          >
            <i
              class="bx bx-link-external box-icon box-icon--effect"
              @click="content.tjData.url"
            ></i
          ></a>
          <a class="px-1 py-3" v-else href="">No Link Available</a>
        </div>
      </div>
      <div v-else-if="content.tjType === 'note-video'" class="ytBed">
        <div class="yt-vid ratio ratio-16x9">
          hello
          <iframe
            :src="
              videoEmbedURLFromURL(
                content.description || content.note || content.note
              )
            "
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div v-else-if="content.tjType === 'note-recording'">
        <video width="100%" height="100%" controls>
          <source :src="content.description || content.note" type="video/mp4" />
        </video>
      </div>
      <div class="px-1 py-3" v-else>
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            wikiDescription__heading
          "
        >
          <h6>{{ formDataObj.label }}</h6>
          <div class="d-flex align-items-center">
            <div class="btn"></div>
            <div class="d-flex">
              <i
                @click="addNoteToGraph(content.description, formDataObj.label)"
                name="export"
                class="
                  box-icon box-icon--effect
                  bx bx-export
                  details-controllers-margin
                "
              ></i>
              <TextToSpeech :speech="content.description" />
              <i
                v-if="!(this.$store.state.routeInfo === 'embed')"
                title="Edit Mode"
                class="
                  bx bx-edit-alt
                  box-icon box-icon--effect
                  details-controllers-margin
                "
                @click="toggleEditMode"
              />
            </div>
          </div>
        </div>
        <TextAnalysis :content="content.description" Mode="Sentences" />
        <!-- <div v-html="contentDescription(content.description)"></div> -->
      </div>
      <div class="px-1 py-3" v-if="content.tjData">
        <h6>Source:</h6>
        <a
          class="px-1 py-3"
          v-if="content.tjData.url"
          :href="content.tjData.url"
          target="_blank"
        >
          <i
            class="
              bx bx-link-external
              noteItem-preference__icon
              box-icon box-icon--effect
            "
            @click="content.tjData.url"
          ></i
        ></a>
        <a class="px-1 py-3" v-else href="">No Link Available</a>
      </div>
    </div>
    <div v-else>
      <NodeForm
        :formData="formDataObj"
        customId="nodeOperation"
        msgData="Hello from G6 Explore"
        title="G6 Explore Node"
        :toggleEditMode="toggleEditMode"
      />
    </div>
  </div>
</template>

<script>
import marked from 'marked';
import moment from 'moment';
import exploreOps from '@/utils/exploreOps';
import { uniqueIdGenerate } from '@/utils/reuse';
import graphReactor from '@/graphReactor';
import NodeForm from './NodeForm.vue';
import TextToSpeech from './TextToSpeech.vue';
import TextAnalysis from './TextAnalysis.vue';

export default {
  data() {
    return {
      formDataObj: {
        id: '',
        label: 'Node Label',
        description: 'Node Description',
        tags: 'Node Tags',
        type: 'circle',
        size: '20',
        color: '#FFFFFF',
        selectedMode: 'Default',
      },
      content: {
        tjType: 'note-text',
        description: "You haven't selected a node yet.",
        tjData: null,
      },
      label: 'details',
      editMode: false,
    };
  },
  methods: {
    async addNoteToGraph(payload, id) {
      const item = {
        id: uniqueIdGenerate('note'),
        value: {
          type: 'note',
          note: payload,
          noteUrl: 'https://app.thoughtjumper.com',
        },
      };
      await exploreOps.addNoteToGraph(item);
      console.log(payload, id);
      graphReactor.exploreInstance.addItem('edge', {
        source: item.id,
        target: id,
        label: 'has note',
        style: {
          endArrow: true,
        },
      });
      graphReactor.exploreInstance.save();
      await this.$store.dispatch('gmodule/saveG6ExploreData');
      graphReactor.exploreInstance.updateLayout();
      this.addNoteInLibrary(payload);
    },

    addNoteInLibrary(note) {
      const value = {
        note,
        noteUrl: 'https://app.thoughtjumper.com',
        type: 'note',
        timestamp: moment().format(),
      };

      const verb = {
        display: {
          en: 'NOTED',
        },
      };

      const data = {
        verb,
        value,
        dataSource: 'tj-client',
      };
      // console.log(data);
      this.$store.dispatch('addToNote', data);
    },
    videoEmbedURLFromURL(url) {
      if (url) {
        const regex = /^https?:\/\/(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\S+)?$/;
        const match = url.match(regex);
        if (match && match[1].length === 11) {
          return `https://www.youtube.com/embed/${match[1]}?rel=0`;
        }
      }
      return '';
      // ^.*(youtu.be\/|v\/|embed\/|watch\?|youtube.com\/user\/[^#]*#([^\/]*?\/)*)\??v?=?([^#\&\?]*).*
    },
    contentDescription(content) {
      return marked(content, { sanitize: true });
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
  },
  watch: {
    payloadDetail(payload) {
      if (payload.content.tjType === 'wikiLinks') {
        this.$store
          .dispatch('getDescription', payload.formDataObj.label)
          .then((res) => {
            this.content = { description: res };
            this.formDataObj = payload.formDataObj;
            console.log(this.content);
          });
      } else if (payload.content.tjType === 'custom-node') {
        this.content = payload.content;
        if (this.content.description === undefined) {
          this.content.description = "You haven't added any description yet.";
        }
        this.formDataObj = payload.formDataObj;
        console.log(this.content.description, this.formDataObj);
      } else {
        this.content = payload.content;
        this.formDataObj = payload.formDataObj;
      }
    },
  },

  computed: {
    payloadDetail() {
      return this.$store.state.payload_detail;
    },
  },
  components: {
    NodeForm,
    TextToSpeech,
    TextAnalysis,
  },
};
</script>

<style lang="scss" scoped>
.details-controllers-margin {
  margin-right: 0.5rem;
}
.yt-vid {
  max-width: 700px;
  height: auto;
}

.ytBed {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
